import { render } from "./TableBankPayrun.vue?vue&type=template&id=37c45ffe"
import script from "./TableBankPayrun.vue?vue&type=script&lang=js"
export * from "./TableBankPayrun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__